import { Rating } from '@conversed/ui/src/components/Rating';
import type React from 'react';
import { useState } from 'react';
import QuickReplyList from '../../containers/QuickReplyList';
import type { Button, RatingData } from '../../types/ChatWindow';
import type { MessageScheme } from '../../types/configs';

interface Props {
  scheme: MessageScheme;
  submitHandler: (...args: any[]) => void;
  data: RatingData;
  isLastMessage: boolean;
}

export const RatingMessage: React.FC<Props> = ({
  submitHandler,
  data,
  scheme,
  isLastMessage,
}) => {
  const { submitText, minRating, maxRating, rating: finalRating } = data;

  const initialRatingValue =
    finalRating && finalRating >= minRating && finalRating <= maxRating
      ? finalRating
      : 0;

  const [clicked, setClicked] = useState(false);
  const [ratingToSubmit, setRatingToSubmit] = useState(initialRatingValue);

  const handleSubmit = () => {
    if (ratingToSubmit && ratingToSubmit >= minRating) {
      submitHandler({
        value: ratingToSubmit?.toString(),
        shouldHideMessage: true,
      });
      setClicked(true);
    }
  };

  const getRatingValue = (value) => {
    setRatingToSubmit(value);
  };

  const buttons: Button[] = [
    { title: submitText, type: 'payload', payload: submitText },
  ];

  return (
    <div className='word-break-style'>
      <Rating
        onSendRatingValue={getRatingValue}
        initialRatingValue={initialRatingValue}
        maxRating={maxRating}
      />
      {clicked || !isLastMessage ? null : (
        <QuickReplyList
          buttons={buttons}
          onClick={handleSubmit}
          scheme={scheme}
        />
      )}
    </div>
  );
};
